import { Image, Divider } from "antd";
import {
  getConstantValue,
  getDateString,
  getFullPath,
} from "../../core/helper/UtilHelper";

export const getPetCPColumns = (genus: any[]) => {
  return [
    {
      title: "No",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Adı",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Çip No",
      dataIndex: "chipNo",
      key: "chipNo",
      render: (value: any) => value ?? "-",
    },
    {
      title: "Pasaport No",
      dataIndex: "passportNo",
      key: "passportNo",
      render: (value: any) => value ?? "-",
    },
    {
      title: "Cins",
      dataIndex: "genus",
      key: "genus",
      render: (value: any) => getConstantValue(value, genus),
    },
    {
      title: "Irk",
      dataIndex: "racial",
      key: "racial",
      render: (value: any) => value ?? "-",
    },
    {
      title: "Doğum Tarihi",
      dataIndex: "birthDate",
      key: "birthDate",
      render: (value: any) => (value ? getDateString(value) : "-"),
    },
  ];
};

const boxStyle = {
  border: "1px solid grey",
  padding: "5px",
  margin: "5px 0",
};

export const getPetCPExpandedRowRender = (
  record: any,
  vaccineStatus: any[],
) => {
  return (
    <>
      <div style={boxStyle}>
        <h3>
          <b>Aşı Listesi ({record.petVaccineRecords.length + " Adet"})</b>
        </h3>
        <ul>
          {record.petVaccineRecords.map(
            (petVaccineRecord: any, index: number) => (
              <li key={index}>
                {petVaccineRecord.vaccine.name} |{" "}
                {getDateString(petVaccineRecord.date)} |{" "}
                {getConstantValue(petVaccineRecord.state, vaccineStatus)}
              </li>
            ),
          )}
        </ul>
      </div>
      <div style={boxStyle}>
        <h3>
          <b>Müdahale Listesi ({record.petProcesses.length + " Adet"})</b>
          <Divider />
          {record.petProcesses.map((petProcess: any, index: number) => (
            <div key={index}>
              <p>
                <b>Şüphe</b> : {petProcess.suspicion ?? "-"}
              </p>
              <p>
                <b>Teşhis</b> : {petProcess.diagnosis ?? "-"}
              </p>
              <p>
                <b>Tedavi</b> : {petProcess.cure ?? "-"}
              </p>
              <p>
                <b>Tarih</b> : {getDateString(petProcess.createdAt)}
              </p>
              {petProcess.media && (
                <Image width={200} src={getFullPath(petProcess.media.uid)} />
              )}
              <Divider />
            </div>
          ))}
        </h3>
      </div>
    </>
  );
};
